import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
export const TargetChart = ({ target }) => {
  const chartData = target?.data;
  const labels = [];
  const sell = [];
  const targets = [];
  for (let i = 0; i < 1; i++) {
    labels.push("کل");
    sell.push(chartData?.sale_target?.all_sell);
    targets.push(chartData?.sale_target?.AmountSaleTarget);
  }
  for (let x = 0; x < chartData?.usersSaleTarget.length; x++) {
    labels.push(
      (chartData?.usersSaleTarget[x]?.user?.FirstName
        ? chartData?.usersSaleTarget[x]?.user?.FirstName
        : "") +
        " " +
        (chartData?.usersSaleTarget[x]?.user?.LastName
          ? chartData?.usersSaleTarget[x]?.user?.LastName
          : "")
    );
    sell.push(chartData?.usersSaleTarget[x]?.sale);
    targets.push(chartData?.usersSaleTarget[x]?.AmountUserSaleTarget);
  }
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };
  const data = {
    labels: labels,
    datasets: [
      {
        label: "تارگت",
        data: targets,
        backgroundColor: "#f1416c",
      },
      {
        label: "فروش",
        data: sell,
        backgroundColor: "#009ef7",
      },
    ],
  };
  return (
    <div className="mx-auto w-50">
      <Bar options={options} data={data} />
    </div>
  );
};

export default TargetChart;
